import {Stack} from '@mui/material';
import {translations} from 'presentation/translations-new';
import React from 'react';
import {StyledLine, StyledListItem, StyledOrderList, StyledUnOrderList} from './styles';
import {LINK_HAP} from './constants';

const {intro, initialInformation, sections} =
	translations['pt-br'].publicFlow.termsOfUse.modalCardHapvida;

function HapvidaTerms() {
	return (
		<Stack>
			<StyledLine>
				{intro.line1.part1}
				<b>{intro.line1.part2}</b>
				{intro.line1.part3}
				<a href={LINK_HAP}>{intro.line1.part4}</a>
				{intro.line1.part5}
			</StyledLine>
			<StyledLine>{intro.line2}</StyledLine>
			<StyledLine $bold>{initialInformation.title}</StyledLine>
			<StyledLine>
				<b>{initialInformation.forWhom.line1.part1}</b>{' '}
				{initialInformation.forWhom.line1.part2}
			</StyledLine>
			<StyledUnOrderList>
				{Object.values(initialInformation.forWhom.list).map(item => (
					<StyledListItem key={item}>{item}</StyledListItem>
				))}
			</StyledUnOrderList>
			{Object.values(initialInformation.forWhom.lines).map(item => (
				<StyledLine key={item} $bold>
					{item}
				</StyledLine>
			))}
			<StyledLine>
				<b>{initialInformation.aboutWhat.line1.part1}</b>{' '}
				{initialInformation.aboutWhat.line1.part2}
			</StyledLine>
			<StyledOrderList>
				{Object.values(initialInformation.aboutWhat.list).map(item => (
					<StyledListItem key={item}>{item}</StyledListItem>
				))}
			</StyledOrderList>
			<StyledLine $bold>{sections.section1.title}</StyledLine>
			{Object.values(sections.section1.items).map(item => (
				<StyledLine key={item}>{item}</StyledLine>
			))}
			<StyledLine $bold>{sections.section2.title}</StyledLine>
			{Object.values(sections.section2.items).map(item => (
				<StyledLine key={item}>{item}</StyledLine>
			))}
			<StyledLine $bold>{sections.section3.title}</StyledLine>
			{Object.values(sections.section3.items1).map(item => (
				<StyledLine key={item}>{item}</StyledLine>
			))}
			{Object.values(sections.section3.list).map(item => (
				<StyledLine $noMargin key={item}>
					{item}
				</StyledLine>
			))}
			<br />
			{Object.values(sections.section3.items2).map(item => (
				<StyledLine key={item}>{item}</StyledLine>
			))}
			<StyledLine $bold>{sections.section4.title}</StyledLine>
			<StyledLine>{sections.section4.items.item1}</StyledLine>
			<StyledOrderList>
				{Object.values(sections.section4.list).map(item => (
					<StyledListItem key={item}>{item}</StyledListItem>
				))}
			</StyledOrderList>
			<StyledLine $bold>{sections.section5.title}</StyledLine>
			<StyledLine>{sections.section5.items1.item1}</StyledLine>
			<StyledUnOrderList>
				{Object.values(sections.section5.list).map(item => (
					<StyledListItem key={item}>{item}</StyledListItem>
				))}
			</StyledUnOrderList>
			{Object.values(sections.section5.items2).map(item => (
				<StyledLine key={item}>{item}</StyledLine>
			))}
			<StyledLine $bold>{sections.section6.title}</StyledLine>
			{Object.values(sections.section6.items).map(item => (
				<StyledLine key={item}>{item}</StyledLine>
			))}
			<StyledLine $bold>{sections.section7.title}</StyledLine>
			{Object.values(sections.section7.items1).map(item => (
				<StyledLine key={item}>{item}</StyledLine>
			))}
			<StyledUnOrderList>
				{Object.values(sections.section7.list).map(item => (
					<StyledListItem key={item}>{item}</StyledListItem>
				))}
			</StyledUnOrderList>
			<StyledLine>{sections.section7.items2.item1}</StyledLine>
			<StyledLine $bold>{sections.section8.title}</StyledLine>
			{Object.values(sections.section8.items).map(item => (
				<StyledLine key={item}>{item}</StyledLine>
			))}
			<StyledLine $bold>{sections.section9.title}</StyledLine>
			{Object.values(sections.section9.items).map(item => (
				<StyledLine key={item}>{item}</StyledLine>
			))}
		</Stack>
	);
}

export default HapvidaTerms;
